import Toggle from "components/Atoms/Toggle"
import React from "react"
import MapControl, { MapControlProps } from "./MapControl"

interface MapSwitchControlProps extends Omit<MapControlProps, "position"> {
  checked?: boolean
  className?: string
  label?: string
  onClick?:
    | ((event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void)
    | undefined
  position?: MapControlProps["position"]
}
const MapSwitchControl = ({
  checked,
  onClick,
  label = "Sticky",
  className = "mb-6 ml-3",
  position = "BOTTOM_CENTER",
}: MapSwitchControlProps) => {
  return (
    <MapControl position={position}>
      <div className="bg-gray">
        <Toggle
          className={className}
          large
          label={label}
          checked={checked}
          onClick={onClick}
        />
      </div>
    </MapControl>
  )
}

export default MapSwitchControl
